import React from "react";
import { Link } from "react-router-dom";
import Icon from "./ui/Icon";
export default function Footer() {
  return (
    <footer className="ui-footer">
      <div>
        <Icon name="spark" size={18} />
        <span>Thoughtfully built by K.H.</span>
      </div>
      <nav aria-label="Footer navigation">
        <Link to="/about">About the workspace</Link>
        <Link to="/workflows">Workflows</Link>
        <Link to="/apps">Apps</Link>
        <span>© {new Date().getFullYear()} KH</span>
      </nav>
    </footer>
  );
}
